// Match a cited snippet to the lines of a page at LINE granularity (MDRS-134).
//
// Used against OCR lines (scanned PDFs have no browser text layer). The backend
// `snippet` is the cited passage, but the AI answer that surfaces it is often
// heavily paraphrased and the OCR of a scanned form drifts too (dates reflowed,
// "R) knee" vs "right knee", broken across boxes). So the snippet and the page
// rarely share a long CONTIGUOUS run of words — an earlier longest-common-run
// approach either missed the real passage or latched onto a clean run of
// generic form boilerplate ("Certificate of Capacity ...").
//
// The actual bag-of-words scoring lives in `utils/wordOverlapMatch.ts` — shared
// with the Scribe-to-Report-Builder back-link (SCRIBE-07), which has the same
// "paraphrased/edited text, no exact position stored" problem against
// transcript segments instead of OCR lines. This file is just the OCR-specific
// naming/entry point.
import { matchSnippetToBlocks } from "@/utils/wordOverlapMatch";

/**
 * Find the line indices a cited snippet touches on a page.
 *
 * Scores each line by its distinct content-word overlap with the snippet and
 * returns the sorted indices of every line that clears the bar, or `null` when
 * nothing does (empty snippet, no lines, or only incidental/stop-word overlap).
 */
export const matchSnippetToLines = (
  lines: string[],
  snippet: string
): number[] | null => matchSnippetToBlocks(lines, snippet);
